import { useAppSelector } from '../hooks/redux';
import {
  mapClassificationToRiskLevel,
  formatClassificationText
} from '../utils/Functions.utils';

export const useAnnexIVData = () => {
  const { createAnnexIVDraftResponse } = useAppSelector(
    (state) => state.documentation,
  );

  const footerData = {
    text: createAnnexIVDraftResponse?.footerNote?.text ?? '',
    email: 'compliai@skyhighgrowth.com',
    reportId: '',
    generatedBy: createAnnexIVDraftResponse?.footerNote?.generatedBy ?? ''
  };

  const headerData = {
    title: 'Annex IV - Technical Documentation',
    entityType: {
      label: 'Entity Type',
      value: createAnnexIVDraftResponse?.documentControl?.entityType ?? ''
    },
    systemName: {
      label: 'AI System Name',
      value: createAnnexIVDraftResponse?.documentControl?.aiSystemName ?? ''
    },
    version: {
      label: 'Version',
      value: createAnnexIVDraftResponse?.documentControl?.version ?? ''
    },
    organizationName: {
      label: 'Organization Name',
      value: createAnnexIVDraftResponse?.documentControl?.organizationName ?? ''
    },
    provider: {
      label: 'Compliance Contact Person',
      value:
        createAnnexIVDraftResponse?.documentControl?.complianceContactPerson ??
        ''
    },
    classification: {
      risk: mapClassificationToRiskLevel(
        createAnnexIVDraftResponse?.documentControl?.classification ?? ''
      ),
      text: formatClassificationText(
        createAnnexIVDraftResponse?.documentControl?.classification ?? ''
      )
    },
    generatedTime:
      createAnnexIVDraftResponse?.documentControl?.dateCreated ?? '',
    reportId: createAnnexIVDraftResponse?.documentControl?.documentId ?? '',
    labels: {
      generatedLabel: 'Date Created',
      idLabel: 'Document ID'
    }
  };

  return { headerData, footerData };
};
